import React from "react";
const NEON = "#00FF99";

// data: [{date:'YYYY-MM-DD', count:number}]
export default function LeaveHeatmap({ loading, data = [] }) {
  // normalize into a simple list for now
  const items = (data || []).slice(0, 14);
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold">Leave Heatmap</h3>
        <span className="text-xs text-white/60">{loading ? "loading…" : `${items.length} days`}</span>
      </div>
      {loading ? (
        <div className="space-y-2">
          {[...Array(4)].map((_,i)=><div key={i} className="h-8 rounded-xl border border-white/10 bg-white/5 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <p className="text-white/60 text-sm">No data in range.</p>
      ) : (
        <div className="space-y-2">
          {items.map((d,i)=>(
            <div key={i} className="flex items-center gap-3">
              <div className="w-28 text-xs text-white/60">{d.date}</div>
              <div className="flex-1 h-2 rounded-full overflow-hidden border border-white/10 bg-black/30">
                <div className="h-full" style={{ width: `${Math.min(100, d.count*6)}%`, backgroundColor: NEON }} />
              </div>
              <div className="w-10 text-right text-xs text-white/70">{d.count}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
